(function(ebusy, $) {

    var countdowns = [];

    startCountdowns();

    $(document).on("modal.load", function() {
        clearCountdowns();
        startCountdowns();
    });

    ebusy.clearCountdowns = clearCountdowns;

    function startCountdowns() {
        $(".ebusy-countdown").each(function() {
            startCountdown($(this));
        });
    }

    function startCountdown(countdownElement) {
        var countdown = new Timer();

        countdown.addEventListener("secondsUpdated", function() {
            countdownElement.closest(".ebusy-countdown-container").removeClass("d-none");
            countdownElement.text(countdown.getTimeValues().toString(['minutes', 'seconds']));
        });

        countdown.addEventListener("targetAchieved", function() {
            countdownElement.trigger(countdownElement.data("event-name"));
        });

        countdown.start({
            countdown: true,
            startValues: { seconds: parseInt(countdownElement.data("countdown-seconds")) }
        });

        countdowns.push(countdown);
    }

    function clearCountdowns() {
        countdowns.forEach(function(countdown) {
            countdown.stop();
        });

        countdowns = [];
    }

})(window.ebusy = window.ebusy || {}, window.jQuery);
